import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TabMenu } from 'primereact/tabmenu';
import { useUserMenu } from '../hooks/useUserMenu';
import '../layout/sass/_tabMenu.scss';
import { useHistory } from 'react-router-dom';
import { FormIndisponivel } from './FormIndisponivel';
import { FormPomarDomestico } from './FormPomarDomestico';
import api from '../api/api';
import { Toast } from 'primereact/toast';
import { FormPessoaPomarDomestico } from './FormPessoaPomarDomestico';

export const UserMenu = () => {

    const {
        errorGettingData,
    } = useUserMenu();
    const [activeIndex, setActiveIndex] = useState(0);
    const [inicioCampanha, setInicioCampanha] = useState(null);
    const [fimCampanha, setFimCampanha] = useState(null);
    const [entregaCampanha, setEntregaCampanha] = useState(null);
    const [temCampanha, setTemCampanha] = useState(false);
    const [cpf, setCpf] = useState("");
    const [solicitarMudas, setSolicitarMudas] = useState(false);
    
    // Estado para controlar se o fluxo é apenas para reimpressão do comprovante
    const [somenteComprovante, setSomenteComprovante] = useState(false);

    const history = useHistory();
    const toast = useRef(null);

    const getPeriodoMatricula = useCallback(async () => {
        try {
            let campanhaAtiva = await api.get(`campanha/ativo`);
            if (campanhaAtiva.data === true) {
                const response = await api.get(`campanha/ativoCampanha`);
                const dados = response.data;
                
                // Converte as datas da API para timestamp numérico
                const inicio = dados.dataInicio ? new Date(dados.dataInicio).getTime() : null;
                const fim = (dados.dataFim || dados.dataTermino) ? new Date(dados.dataFim || dados.dataTermino).getTime() : null;
                const entrega = dados.dataEntrega ? new Date(dados.dataEntrega).getTime() : null;

                setInicioCampanha(inicio);
                setFimCampanha(fim);
                setEntregaCampanha(entrega);
                setTemCampanha(true);

                // Define automaticamente somenteComprovante se já tiver ultrapassado a dataFim
                const agoraTimestamp = new Date().getTime();
                if (fim !== null && agoraTimestamp > fim) {
                    setSomenteComprovante(true);
                }
            } else {
                setTemCampanha(false);
            }
        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter periodo da campanha', detail: error.toString() });
        }
    }, []);

    useEffect(() => {
        getPeriodoMatricula();
    }, [getPeriodoMatricula]);

    const agora = new Date().getTime();

    // A campanha está acessível se existe uma campanha ativa E ainda não passou da data/hora de entrega
    const campanhaAcessivel = temCampanha && entregaCampanha && agora <= entregaCampanha;

    const items = [
        campanhaAcessivel ?
        { label: 'Pomar Domêstico', icon: 'pi pi-id-card' }
        :
        { label: 'Indisponível', icon: 'pi pi-id-card' },
        { label: 'Admin', icon: 'pi pi-id-card' } 
    ];

    const handleTabChange = (index) => {
        setActiveIndex(index);
        if (index === 1) {
            history.push('/login');
        }
    };

    return (
        <div style={{ height: '100vh', backgroundColor: '#fff', overflow: 'auto' }}>
            <Toast ref={toast} position="bottom-right" />
            <TabMenu
                model={items}
                activeIndex={activeIndex}
                onTabChange={(e) => handleTabChange(e.index)}
                className="custom-tab-menu"
            />
            {
            errorGettingData ?
                <></>
                :
                campanhaAcessivel ?
                    solicitarMudas === true ?
                    <div className="card p-grid p-col-12 p-jc-center p-mx-0 p-p-0">
                        <FormPessoaPomarDomestico 
                            setSolicitarMudas={setSolicitarMudas} 
                            cpf={cpf}
                            somenteComprovante={somenteComprovante}
                        />
                    </div>
                    :
                    <div className="card p-grid p-col-12 p-jc-center p-mx-0 p-p-0" key={solicitarMudas}>
                        <FormPomarDomestico 
                            setSolicitarMudas={setSolicitarMudas} 
                            setCpf={setCpf}
                            setSomenteComprovante={setSomenteComprovante}
                        />
                    </div>
                : 
                <div className="card p-grid p-col-12 p-jc-center p-mx-0 p-p-0">
                    <FormIndisponivel />
                </div>
            }
        </div>
    );
};